import { render, staticRenderFns } from "./OpinionEditor.vue?vue&type=template&id=ce4f6562&scoped=true"
import script from "./OpinionEditor.vue?vue&type=script&lang=js"
export * from "./OpinionEditor.vue?vue&type=script&lang=js"
import style0 from "./OpinionEditor.vue?vue&type=style&index=0&id=ce4f6562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce4f6562",
  null
  
)

export default component.exports